export const emptyPaginationMeta = () => ({
  total_count: 0,
  page: 1,
  per_page: 25,
  total_pages: 0,
});

export const normalizePaginationMeta = (meta = {}, fallback = {}) => ({
  ...emptyPaginationMeta(),
  ...fallback,
  ...meta,
});

export const mergeUniqueRecords = (currentRecords, nextRecords) => {
  const records = new Map(
    currentRecords.map(record => [String(record.id), record])
  );
  nextRecords.forEach(record => records.set(String(record.id), record));
  return Array.from(records.values());
};
